import React, { Component } from 'react';
import './style.scss';
import $ from 'jquery';
import { Route, Switch, BrowserRouter } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import Menu from './components/Menu/Menu.js';
import ContentPage from './pages/ContentPage/ContentPage.js';
import Firstpage from "./pages/Firstpage/Firstpage.js";
import Secondpage from "./pages/Secondpage/Secondpage.js";
import Thirdpage from "./pages/Thirdpage/Thirdpage.js";
import Fourthpage from "./pages/Fourthpage/Fourthpage.js";
import Fifthpage from "./pages/Fifthpage/Fifthpage.js";
import Sixthpage from "./pages/Sixthpage/Sixthpage.js";
import Seventhpage from "./pages/Seventhpage/Seventhpage.js";
import Eightpage from "./pages/Eightpage/Eightpage.js";
import Ninthpage from "./pages/Ninthpage/Ninthpage.js";
import Tenthpage from "./pages/Tenthpage/Tenthpage.js";
import Eleventhpage from "./pages/Eleventhpage/Eleventhpage";
import Twelvethpage from "./pages/twelvethpage/Twelvethpage";
import Thirteenthpage from "./pages/Thirteenthpage/Thirteenthpage";
window.jQuery = $;
window.$ = $;
global.jQuery = $;

const supportsHistory = 'pushState' in window.history;
let isScrollable = false;
let prevButton = '/';
let nextButton = '/second';

class PageBuild extends Component{
  constructor(props) {
    super(props);
    this.state = {
      prevButton: prevButton,
      nextButton: nextButton,
      prevPossible: false,
      nextPossible: true,
      isScrollable: isScrollable
    };
  }
  updateLinks = (prevLink, nextLink, prevPossible, nextPossible, isScrollable) => {
      this.setState({
        nextPossible: false,
        prevPossible: false
      });
      setTimeout(() => this.setState(prevState => ({
        prevButton: prevLink,
        nextButton: nextLink,
        prevPossible: prevPossible,
        nextPossible: nextPossible,
        isScrollable: isScrollable
      })), 500);
    window.scrollTo(0, 0);
  }
  scrollDown = (target) => {
    const height = $('#intro').height();
    window.scrollTo(0, height);
  }
  componentDidMount(){
    const prevLink = this.state.prevButton;
    const nextLink = this.state.nextButton;
  }
  componentDidUpdate(){

  }
  render() {
    return (
      <div className="pagewrapper">
        <BrowserRouter forceRefresh={!supportsHistory}>
          <div>
          <Menu prevbutton={this.state.prevButton} nextbutton={this.state.nextButton} prevpossible={this.state.prevPossible} nextpossible={this.state.nextPossible} isScrollable={this.state.isScrollable}/>
            <main>
              <Route
                render={({ location }) => {
                  const { pathname } = location;
                  return (
                    <TransitionGroup>
                      <CSSTransition
                        key={pathname}
                        classNames="page"
                        timeout={{
                          enter: 500,
                          exit: 500,
                        }}
                      >
                        <Route
                          location={location}
                          render={() => (
                            <Switch>
                              <Route
                                exact
                                path={`${process.env.PUBLIC_URL}/overzicht-editie-9`}
                                render={(props) => <ContentPage {...props} updatelinks={this.updateLinks} />}
                              />
                              <Route
                                exact
                                path={`${process.env.PUBLIC_URL}/`}
                                render={(props) => <Firstpage {...props} updatelinks={this.updateLinks} />}
                              />
                              <Route
                                exact
                                path={`${process.env.PUBLIC_URL}/astrael-is-anders-met-ambitie-en-dromen`}
                                render={(props) => <Secondpage {...props} updatelinks={this.updateLinks} />}
                              />
                              <Route
                                exact
                                path={`${process.env.PUBLIC_URL}/duurzaamheid-kent-geen-tijd-brauer-groen-over-de-volgende-stap-in-groenbeheer`}
                                render={(props) => <Thirdpage {...props} updatelinks={this.updateLinks} />}
                              />
                              <Route
                                exact
                                path={`${process.env.PUBLIC_URL}/een-andere-kijk-op-een-duurzame-toekomst`}
                                render={(props) => <Fourthpage {...props} updatelinks={this.updateLinks} />}
                              />
                              <Route
                                exact
                                path={`${process.env.PUBLIC_URL}/behandelingen-voor-elk-huidtype-dat-verdient-een-schoonheidsprijs`}
                                render={(props) => <Fifthpage {...props} updatelinks={this.updateLinks} />}
                              />
                              <Route
                                exact
                                path={`${process.env.PUBLIC_URL}/partners-voor-service`}
                                render={(props) => <Sixthpage {...props} updatelinks={this.updateLinks} />}
                              />
                              <Route
                                exact
                                path={`${process.env.PUBLIC_URL}/mensen-uitdagen-om-tot-het-uiterste-te-gaan`}
                                render={(props) => <Seventhpage {...props} updatelinks={this.updateLinks} />}
                              />
                              <Route
                                exact
                                path={`${process.env.PUBLIC_URL}/van-onvoorstelbaar-naar-onweerstaanbaar-extended-reality-xr-maakt-het-verschil`}
                                render={(props) => <Eightpage {...props} updatelinks={this.updateLinks} />}
                              />
                              <Route
                                exact
                                path={`${process.env.PUBLIC_URL}/influencers-bestaan-al-veel-langer-alleen-werden-ze-niet-zo-genoemd`}
                                render={(props) => <Ninthpage {...props} updatelinks={this.updateLinks} />}
                              />
                              <Route
                                exact
                                path={`${process.env.PUBLIC_URL}/5-tips-voor-het-gebruik-van-humor-op-social-media`}
                                render={(props) => <Tenthpage {...props} updatelinks={this.updateLinks} />}
                              />
                              <Route
                                exact
                                path={`${process.env.PUBLIC_URL}/space32-door-de-ogen-van-appart`}
                                render={(props) => <Eleventhpage {...props} updatelinks={this.updateLinks} />}
                              />
                              <Route
                                exact
                                path={`${process.env.PUBLIC_URL}/space32-volgens-bart-jansen-het-is-voor-mij-een-denktank-van-twee-bedrijven-die-elkaar-aanvullen`}
                                render={(props) => <Twelvethpage {...props} updatelinks={this.updateLinks} />}
                              />
                              <Route
                                exact
                                path={`${process.env.PUBLIC_URL}/designer-aan-het-woord-de-gedachte-achter-het-logo-van-space32`}
                                render={(props) => <Thirteenthpage {...props} updatelinks={this.updateLinks} />}
                              />
                            </Switch>
                          )}
                        />
                      </CSSTransition>
                    </TransitionGroup>
                  );
                }}
              />
            </main>
          </div>
        </BrowserRouter>
      </div>
    )

  }


}



export default PageBuild;
